/* eslint-disable no-param-reassign */
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import API from '../../api/api';
import { LOADING_STATUSES } from 'src/constants/statuses';
import { getTokenData } from 'src/utils/api';
import { isResponseSuccess } from 'src/utils/api';

export const loadAllPlans = createAsyncThunk(
  'plans/load',
  async ({}, { rejectWithValue }) => {
    try {
      const response = await API(getTokenData()).BASIC.PLANS.load();
      if (isResponseSuccess(response.status)) {
        return response.data || [];
      }
      return {};
    } catch (error) {
      return rejectWithValue(error.toString);
    }
  },
);

const initialState = {
  plans: [],
  status: LOADING_STATUSES.IDLE,
};

const plansSlice = createSlice({
  name: 'plans',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(loadAllPlans.pending, (state) => {
        state.status = LOADING_STATUSES.LOADING;
      })
      .addCase(loadAllPlans.fulfilled, (state, action) => {
        state.plans = action.payload;
        state.status = LOADING_STATUSES.SUCCEEDED;
      })
      .addCase(loadAllPlans.rejected, (state, action) => {
        state.status = LOADING_STATUSES.FAILED;
        state.error = action.payload;
      });
  },
});

export default plansSlice.reducer;
